// Export respective env file based on process.ENV
var trp: any;
if (process.env.NODE_ENV === 'development') {
    trp = require('./dev.config').env;
} else if (process.env.REACT_APP_ENV === 'stage') {
    trp = require('./stg.config').env;
} else {
    trp = require('./prod.config').env;
}
export default trp;